import { useState, useEffect } from 'react';

// Единый брейкпоинт для адаптива ЛК врача. Все стили — inline JS-объекты
// (не CSS), поэтому адаптив делаем через JS-детект ширины экрана + условное
// подмешивание стилей, а не через media queries.
export const MOBILE_BREAKPOINT = 768;

export default function useIsMobile(breakpoint = MOBILE_BREAKPOINT) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= breakpoint : false
  );

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= breakpoint);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [breakpoint]);

  return isMobile;
}
